import { AnimatePresence, motion } from 'motion/react';

import { useVote } from './hooks/useVote';
import { useCarousel } from './hooks/useCarousel';

import { Advt } from './components/Advt/Advt';
import { Rnd } from './components/Rnd/Rnd';

const stateSlow = 'S2';
const stateFast = 'S3';
const stateWin = 'S4';
const stateClean = 'S5';

const objStatesRnd = {
  stateSlow,
  stateFast,
  stateWin,
  stateClean,
};

const statesRnd = [stateSlow, stateFast, stateWin, stateClean];

function App() {
  const { voteState, currentState } = useVote();
  const { showedMessages, winnerMessage, speed } = useCarousel({
    currentState,
    objStatesRnd,
  });

  return (
    <div className="app-wrapper" style={{ '--speed': `${speed}ms` }}>
      <AnimatePresence mode="wait">
        {currentState === 'S1' && (
          <motion.div
            className="motionBlock"
            key={`advt-${currentState}`}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.5 }}
          >
            <Advt title={voteState?.title} />
          </motion.div>
        )}

        {statesRnd.includes(currentState) && (
          <motion.div
            className="motionBlock"
            key={'msgs'}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.5 }}
          >
            <Rnd
              voteState={voteState}
              winnerMessage={winnerMessage}
              showedMessages={showedMessages}
              speed={speed}
              isStateWin={stateWin === currentState}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
